import React from 'react';
import { useTranslate } from 'react-polyglot';

import styles from './BarGraphCard.module.scss';
import StatisticsCard from '../../../../Shared/StatisticsCard/StatisticsCard';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top' as const,
        },
        title: {
            display: false,
            text: 'Chart title',
        }
    }
};

function BarGraphCard(props: BarGraphCardProps) {
    return (
        <StatisticsCard
            title={props.title}
        >
            <div className={styles.cardcontent}>
                <Bar
                    options={
                        {
                            ...options,
                            ...(props.options ?? {})
                        }
                    }
                    data={props.data}
                    redraw={true}
                />
            </div>
        </StatisticsCard>
    );
}

class BarGraphCardProps {
    title!: string;
    data!: any;
    options?: any;
}

export default BarGraphCard;